module.exports = __webpack_public_path__ + "static/media/heap_snapshot_large_header.c01f8ed4.svg";